import { atom } from 'jotai';

export const graduateShareModalAtom = atom<boolean>(false);
export const graduateDownloadModalAtom = atom<boolean>(false);
